import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  AfterViewInit,
  OnChanges,
} from '@angular/core';

import { ImagePanZoomComponent, IImageData } from './image-pan-zoom.component';

@Component({
  selector: 'image-pan-zoom-viewer',
  styleUrls: ['./image-pan-zoom-viewer.component.scss'],
  templateUrl: './image-pan-zoom-viewer.component.html',
})
export class ImagePanZoomViewerComponent implements AfterViewInit, OnChanges {
  @ViewChild('imagePanZoom', { static: false }) public imagePanZoom: ImagePanZoomComponent;
  @Input() public imageSrcUrl: string;
  @Input() public editMode: boolean;
  @Input() public fileData: string[];
  @Input() public fitToContainer: boolean;
  @Output() public removePhoto = new EventEmitter();
  @Output() public rotatePhoto = new EventEmitter();
  public isLoading: boolean = true;
  public hideZoomLevel: boolean = true;

  public ngAfterViewInit(): void {
    this.useFileDataIfNeeded();
  }

  public ngOnChanges(): void {
    this.useFileDataIfNeeded();
  }

  public imageLoadComplete(): void {
    this.isLoading = false;
    // To avoid showing 100% and then updating to actual zoom level
    setTimeout(() => this.hideZoomLevel = false, 0);
  }

  public rotateInDegrees(degrees: number): void {
    const rotatedImageData: IImageData = this.imagePanZoom.rotateInDegrees(degrees);
    this.rotatePhoto.emit({ data: rotatedImageData.base64Encoded[1], src: rotatedImageData.imageData });
  }

  private useFileDataIfNeeded(): void {
    if (this.editMode && this.fileData && this.fileData[2]) this.imageSrcUrl = this.fileData[2];
  }
}
